import { Place } from '~/models/Place'
import { BaseRepository } from '../baseRepository'
import { ApiPlace } from './apiTypes'
import { BackendPlaceEntityMapper } from './entityMapper'

export class PlaceRepository extends BaseRepository {
	static resource = 'v1/places'

	static async retrievePlace(id: string): Promise<Place> {
		const response: Record<string, ApiPlace | any> = await this.get(`${this.resource}/${id}/`)
		return BackendPlaceEntityMapper.toPlace(response.place, response.spot)
	}
}
